<template>
  <div
    class="pos-schedule-container overflow-y pt-5"
    :class="!noAuthLogin ? 'd-none !important' : 'd-block !important'"
  >
    <div class="posUserCollection-title">
      <h3 class="d-flex justify-content-center">Fnb Transactions</h3>
    </div>
    <button @click="closeModalSection()" class="btn-modal-close">
      &times;
    </button>

    <div class="row w-100">
      <div class="col-lg-4 col-xl-3 align-self-center mb-4">
        <div class="input-material">
          <div class="add-datepicker">
            <button
              class="btn-clearDate"
              v-if="transaction_date"
              v-on:click="transaction_date = ''"
            >
              ✖
            </button>
            <Datepicker
              :monday-first="true"
              ref="programaticOpen"
              v-model="transaction_date"
              name="trans_date"
              id="trans_date"
              @input="onChangeDate()"
              :typeable="true"
              v-validate="'required'"
            ></Datepicker>
            <label :class="transaction_date ? 'active' : ''">{{
              $t("date")
            }}</label>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="br-10">
          <div>
            <b-form-input
              @input="onSearch"
              id="searchPosUserTrn"
              type="search"
              class="br-10"
              v-model="search_value"
              placeholder="Search..."
              ref="searchinputele"
            ></b-form-input>
            <VkeyboardFloat
              :ID="'searchPosUserTrn'"
              :onClickFun="
                () => {
                  showVKeyboard = !showVKeyboard;
                }
              "
            />
            <Vkeyboard
              :inputName="'searchPosUserTrn'"
              :showOrHide="showVKeyboard"
              :initialValue="search_value"
              @onChangeEvent="() => {}"
              @onKeyEnter="onSearch"
              @changeKeyboardInput="search_value = $event"
              @onClickClose="
                () => {
                  showVKeyboard = false;
                }
              "
            />
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelect($event, Cinema, 'Cinema')"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedBookingSource && selectedBookingSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("bookingsource", 1) }}</label
              >
              <b-dropdown
                :text="selectedBookingSource"
                name="selectbookingsource"
                id="selectbookingsource"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(booking, bookingIndex) in BookingSourceList"
                  :key="bookingIndex"
                  v-on:click="onSelect($event, booking, 'BookingSource')"
                  >{{ booking.bs_source }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="GetTransactionList"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div> -->
    </div>

    <div class="swc-report">
      <table class="swc-report-table" border="1">
        <thead class="bg-lightgrey">
          <tr>
            <!-- <th>{{ $tc("booking") }} {{ $tc("code") }}</th> -->
            <th>{{ $tc("order") }} {{ $tc("code") }}</th>
            <th>{{ $tc("item") }} {{ $tc("name") }} ({{ $tc("quantity") }})</th>
            <th>{{ $tc("revenue") }}</th>
            <th>{{ $tc("bookingsource") }}</th>
            <th>
              {{ $tc("transaction") }} {{ $tc("date") }} & {{ $tc("time") }}
            </th>
            <th>{{ $tc("payment") }} {{ $tc("mode") }}</th>
            <th>{{ $tc("offer") }}</th>

            <!-- <th>{{ $tc("view") }} {{ $tc("details") }}</th> -->
            <th>{{ $t("Print") }}</th>
          </tr>
        </thead>
        <tbody
          v-for="(fnbtrans, fnbtransIndex) in transactionList"
          :key="fnbtransIndex"
          class="sph-report"
        >
          <tr>
            <!-- <td>{{fnbtrans.sb_booking_code}}</td> -->
            <td>{{ fnbtrans.order_code }}</td>
            <td class="text-left">{{ fnbtrans.item_with_quantity }}</td>
            <td>
              {{ fnbtrans.ft_currency_name }}
              {{ fnbtrans.ft_total_amount.toFixed(this.MIN_FRACTION_DIGITS) }}
            </td>
            <td class="text-left">{{ fnbtrans.bs_source }}</td>
            <td>{{ fnbtrans.ft_date_time | fulldatemonparse }}</td>
            <td class="text-left">{{ fnbtrans.fst_payment_mode }}</td>

            <td :class="fnbtrans.ft_offer_name ? 'text-left' : ''">
              {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
            </td>
            <td style="text-align:center">
              <b-button
                variant="default"
                @click="
                  onPrintHandler(
                    fnbtrans.fnb_transaction_id,
                    fnbtrans.order_code
                  )
                "
                class="btn-blue v-step-1"
                >{{ $t("Print") }}</b-button
              >
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td v-if="transactionList.length == 0" colspan="8">
              <!-- <p class="text-center">{{ $tc("NoRecords") }}</p> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <div class="mt-4">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
    <ManagerAuthLogin
      :moduleName="'posFnb_transaction'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_posFnb_transaction'"
    />
    <ManagerAuthLogin
      :moduleName="'posFnb_transaction'"
      :onCheckAuth="onCheckAuthenticationLogin"
      :refId="'authManager_pos_fnb_transaction_login'"
    />
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import MasterService from "@/services/MasterService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import NoRecords from "@/components/Partials/NoRecords.vue";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import Printd from "printd";
import { EventBus } from "@/main";
import { Role, CLIENT_NAME } from "@/helper/Role";
import { BASEURL } from "@/config/index";

export default {
  props: {
    childComponents: {
      type: Object,
    },
    onClickHandler: {
      type: Function,
    },
  },
  components: { DatePicker, NoRecords, VueHtml2pdf, ManagerAuthLogin },
  data() {
    return {
      fnb_order_code: null,
      noAuth: true,
      search_value: "",
      showVKeyboard: false,
      fnb_transaction_id: null,
      user_id: null,
      EjsData: null,
      LoggedUserId: null,
      transaction_date: "",
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 2,
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      btenable: false,
      isRoleID: true,
      transactionList: [],
      selectedCinema: "",
      cine_id: null,
      Cinemas: [],
      BookingSourceList: [],
      selectedBookingSource: "",
      bs_id: null,
      transaction_date: new Date(),
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      CinemasCopy: [],
      searchCinema: "",
      isReprint: false,
      noAuthLogin: false,
    };
  },
  computed: {
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
    DirectPrint() {
      return this.$store.getters.DirectPrint;
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
    },
    MANAGER_AUTH_FOR_REPRINT() {
      return this.$store.getters.MANAGER_AUTH_FOR_REPRINT;
    },
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").user_id &&
        this.secureStore.get("USINFO").user_id
        ? this.secureStore.get("USINFO").user_id +
            " " +
            this.secureStore.get("USINFO").user_id
        : "Admin";
    },
  },
  beforeMount() {
    this.transaction_date = moment().format("YYYY-MM-DD");
    this.getviewingnumber();
    this.LoggedUserId = this.secureStore.get("USINFO").user_id;
    // let obj = this.secureStore.get("USINFO").cinema_id;
    // let roleid = this.secureStore.get("USINFO").role_id;
    const { user_id, cinema_id } = this.secureStore.get("USINFO");
    // if (true) {
    //   this.isRoleID = false;
    //   this.getCinemaList(obj);
    // } else {
    //   this.getCinemaList(obj);
    // }
    this.GetTransactionList();
    // this.GetBookingSources();

    // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.selectedCinema = CinemaObj.cine_name;
    //   this.cine_id = CinemaObj.cine_id;
    //   this.GetTransactionList();
    // }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.cine_id = CinemaObj.cine_id;
      this.GetTransactionList();
    },
  },

  mounted() {
    this.user_id = this.secureStore.get("USINFO").user_id;
    if (this.MANAGER_AUTH_FOR_CHANGES == "Y" && !this.noAuthLogin) {
      this.$bvModal.show("authManager_pos_fnb_transaction_login");
    } else {
      this.noAuthLogin = true;
    }
    // this.getCountriesList();
    // this.SelectedCountryCode = this.getCustMobCode;
  },
  methods: {
    onCheckAuthenticationLogin(response) {
      const { valid } = response;
      if (valid) {
        this.noAuthLogin = true;
        this.$bvModal.hide("authManager_pos_fnb_transaction_login");
      }
    },
    onChangeSearch(input) {
      this.search_value = input;
      this.onSearch();
    },
    onChangeDate: _.debounce(function() {
      this.GetTransactionList();
    }, 1.5 * 1000),
    onSearch: _.debounce(function() {
      this.GetTransactionList();
    }, 1.5 * 1000),
    onKeyPress(button) {
      if (button == "{enter}") {
        this.GetTransactionList();
      }
    },

    closeModalSection: function() {
      this.onClickHandler({ name: "posUserFnbTransaction" });
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Reports" + date.getTime();
      this.htmlToPdfOptions.filename = this.pdfFileName;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(18);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    excelDownload() {
      //  let temp_arr = [];
      // new_records.map(x => {
      //   x.fnb_Records.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})

      let new_records = this.transactionList;
      // let temp_arr = this.getBoxOfficeReport;
      // temp_arr = this.getBoxOfficeReport.map(x => {
      // x.paymentData.map(z => {
      // let obj = {
      // ...x,
      // ...z
      // };
      // new_records.push(obj);
      // });
      // });
      // let temp_arr_fnb = this.getBoxOfficeFnBReport.map(p => {
      // p["booking_source"] = "FNB";
      // new_records.push(p);
      // });
      // console.log("new_records", new_records);
      let dateparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "FnBTransaction Report",
          columns: [
            {
              value: "order_code",
              label: "Order Code",
            },
            {
              value: "item_with_quantity",
              label: "Item Name (Quantity)",
            },
            {
              value: (row) =>
                row.ft_currency_name + row.ft_total_amount.toFixed(this.MIN_FRACTION_DIGITS),
              label: "Revenue",
            },
            {
              value: "bs_source",
              label: "Booking Source",
            },
            {
              value: (row) => fulldatemonparse(row.ft_date_time),
              label: "Transaction Date & Time",
            },
            {
              value: "fst_payment_mode",
              label: "Payment Mode",
            },
            {
              value: (row) => (row.ft_offer_name ? row.ft_offer_name : "-"),
              label: "Offer",
            },
          ],
          content: new_records,
        },
      ];
      let settings = {
        fileName: `FnB Transaction Report${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },

    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetTransactionList();
      } else {
        this.currentPage = event;
        this.GetTransactionList();
      }
    },
    toDetails(object) {
      this.$router.push({
        name: "View F&B Transaction",
        params: { ft_id: object.ft_id },
      });
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.fetchTransactionDetail.cinema_id = x.cine_id;
                this.selectedCinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    // GetBookingSources: function() {
    //   PosFnbService.BookingSources()
    //     .then(response => {
    //       const { data } = response;

    //       if (data.status) {
    //         if (data.Records && data.Records.length > 0) {
    //           this.BookingSourceList = data.Records;
    //         } else {
    //           this.$toasted.show(data.message);
    //         }
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },
    // onSelect: function(event, params, type) {
    //   if (type == "Cinema") {
    //     this.selectedCinema = params.cine_name;
    //     this.cine_id = params.cine_id;
    //     this.searchCinema = "";
    //     this.onSearchCinema();
    //     this.$store.dispatch("selectDropdownCinema", params);
    //   } else if (type == "BookingSource") {
    //     this.selectedBookingSource = params.bs_source;
    //     this.bs_id = params.bs_id;
    //   }
    // },
    GetTransactionList: function() {
      // this.btenable = true;

      let payload = {
        transaction_date: this.transaction_date
          ? moment(this.transaction_date).format("YYYY-MM-DD")
          : "",
        limit: this.perPage,
        user_id: this.LoggedUserId,
        currentPage: this.currentPage,
        date: moment(this.transaction_date).format("YYYY-MM-DD"),
        cinema_id:
          this.secureStore.get("USINFO") &&
          this.secureStore.get("USINFO")["cinema_id"]
            ? this.secureStore.get("USINFO").cinema_id
            : null,
        bs_id: this.bs_id,
        search_value: this.search_value,
      };
      if (!this.transaction_date) {
        return this.$toasted.show("Please Select Transaction Date");
      } else {
        let loader = this.$loading.show();
        PosFnbService.GetFnBPosTransactions(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;

            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                // this.onClickHandler("posUserFnbTransaction");
                this.transactionList = data.Records;
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                  this.selectedvalue =
                    this.selectedvalue < 10 ? 10 : this.selectedvalue;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              } else {
                this.transactionList = [];
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
                this.$toasted.show("No Records Found");
              }
            } else {
              this.transactionList = [];
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    onCheckAuthentication(response) {
      const { valid, name } = response;
      if (valid) {
        if (name == "posFnb_transaction") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_posFnb_transaction");
          this.onPrintHandler(this.fnb_transaction_id, this.fnb_order_code);
        }
      }
    },
    onPrintHandler: function(fnb_transaction_id, order_code) {
      // let trx = this.transactionList.filter(x => x.fnb_transaction_id == this.fnb_transaction_id)[0] || ''

      let payload = {
        OrderCode: order_code || "",
        Type: "Print",
        UserID: this.user_id,
        isReprint: this.isReprint,
        fnb_transaction_id: this.fnb_transaction_id,
        cinemaId: this.secureStore.get("USINFO").cinema_id,
      };
      if (this.MANAGER_AUTH_FOR_REPRINT == "Y" && !this.noAuth) {
        this.fnb_transaction_id = fnb_transaction_id;
        this.fnb_order_code = order_code;
        this.$bvModal.show("authManager_posFnb_transaction");
      } else {
        const { cinema_id } = this.secureStore.get("USINFO");
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              if (CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME) {
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "fnb",
                  ...payload,
                });

                setTimeout(() => {
                  this.$socket.emit("on_print_ticket", {
                    baseurl: BASEURL,
                    ttype: "fnb-security",
                    ...payload,
                  });
                }, 4000);
              } else {
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "fnb",
                  ...payload,
                });
              }
              if (true) {
                console.log("test_electron1");
              }
            }
          } catch (err) {
            console.log("Error:", err);
          }
        } else {
          let isReprint = true;

          PosFnbService.GetFnbOrderEjs(payload)
            .then(async (response) => {
              const { data } = response;

              this.EjsData = data;

              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, []);
                }
              });
            })
            .catch((err) => {
              console.log("Error:", err);
            });
          // PosFnbService.GetFnbOrderEjs(payload)
          //   .then(async response => {
          //     const { data } = response;

          //     this.EjsData = data;

          //     this.$nextTick(() => {
          //       const p = new Printd();
          //       if (this.$refs.onPrint && this.EjsData != null) {
          //         p.print(this.$refs.onPrint, []);
          //       }
          //     });
          //   })
          //   .catch(err => {
          //     console.log("Error:", err);
          //   });
        }
      }
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posUserFnbTransaction.vue